const REDACTED = 'REDACTED';

/**
 * Finds and redacts email address
 * from a given url string.
 *
 * @param url string
 * @returns string
 */
export const fromURL = (url: string) =>
  // eslint-disable-next-line no-useless-escape
  url.replace(/\/[^\/]*?(?:@|%40).*?(\/|$)/, `/${REDACTED}/`);

/**
 * Finds and redacts email address
 * from a given string.
 *
 * @param str string
 * @returns string
 */
export const fromString = (str: string) =>
  str.replace(/([a-zA-Z0-9+._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi, REDACTED);
